import React from 'react';
import styles from './styles.module.scss';

const ErrorMessage = props => (
  <span className={styles.error}>{props.message || props.children}</span>
);

export default ErrorMessage;
